import { Typography } from "@mui/material";
import { ReactNode } from "react";

// The dummy's page heading: left-aligned, 32px on a computer and 26px on a
// phone, in the display face.
const Title = ({
  children,
  textColor = "normal",
}: {
  children: ReactNode;
  textColor?: string;
}) => {
  return (
    <Typography
      component="h1"
      sx={{
        fontWeight: 700,
        fontFamily:
          '"Bricolage Grotesque", ui-sans-serif, system-ui, sans-serif',
        fontSize: { xs: 26, sm: 32 },
        lineHeight: 1.12,
        letterSpacing: "-.015em",
        textWrap: "balance",
        color: textColor,
      }}
    >
      {children}
    </Typography>
  );
};

export default Title;
